import { cn } from "@/lib/utils";
import { Link, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

export const Navbar = () => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <nav
      className={cn(
        "fixed top-0 left-0 right-0 z-50",
        "backdrop-blur-md bg-background/30",
        "border-b border-transparent",
        "before:absolute before:inset-x-0 before:bottom-0 before:h-[1px]",
        "before:bg-gradient-to-r before:from-gray-100 before:via-[#9b87f5] before:to-gray-100"
      )}
    >
      {/* <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex-1">
            <Link to="/" className="text-xl font-bold text-foreground">
              Joylo AI Engr.
            </Link>
          </div>

          <div className="hidden md:flex space-x-8 items-center">
            <Link
              to="/about"
              className="text-foreground/90 hover:text-foreground transition-colors duration-200"
            >
              About
            </Link>
            <div className="flex items-center space-x-4">
              {isAuthenticated ? (
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={handleLogout}
                  className="text-foreground/90 hover:text-foreground transition-colors duration-200"
                >
                  <LogOut className="h-5 w-5" />
                </Button>
              ) : (
                <>
                  <Link
                    to="/login"
                    className="text-foreground/90 hover:text-foreground transition-colors duration-200"
                  >
                    Login
                  </Link>
                  <Link
                    to="/signup"
                    className="px-4 py-2 rounded-md bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
                  >
                    Sign up
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </div> */}
    </nav>
  );
};
